// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2x-1";
export var movingGradient = "_2x-4";
export var movingGradientBlock = "_2x-2";
export var skeleton = "_2x-0";
export var skeletonText = "_2x-3";